import { get } from "utils/lodash";
export const REVIEW_SELECTION = `
    id
    status
    type
    comment
    rating
    shop {
        id
        name
    }
    booking {
        id
        displayName
        status
    }
    populatedUser {
        id
        name
    }
    createdAt
`;

// user {
//     id
//     name
// }
export const REVIEW_STATS_SELECTION = `
    total
    byPoints {
        BAD
        MEDIUM
        GOOD
        EXCELLENCE
    }
`;

/** Query review đã duyệt của 1 shop — dùng chung cho server (page.tsx) và client (phân trang). */
export const REVIEW_PAGE_SIZE = 10;

export const buildReviewQuery = (payload: {
  shopId: string;
  page: number;
  limit: number;
}) => {
  return {
    where: {
      shop: {
        equals: payload.shopId,
      },
      status: {
        equals: "approved",
      },
    },
    sort: "-createdAt",
    fetchPolicy: "no-cache",
    page: get(payload, "page", 1),
    limit: get(payload, "limit", REVIEW_PAGE_SIZE),
  };
};
